import React from 'react';
import { Input } from 'antd';
import cn from 'classnames';
import styles from './index.module.scss';

const BaseField = ({
  className,
  hasAddonAfter,
  value,
  onChange,
  fieldProps,
}) => {
  return (
    <Input
      {...fieldProps}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={cn(styles.root, className, {
        [styles.addonAfter]: hasAddonAfter,
      })}
    />
  );
};

export default BaseField;
